module.exports = __webpack_public_path__ + "static/img/capital-scale3.26540ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/capital-scale3.png
// module id = kcVC
// module chunks = 0